var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');
var Animated = require('./Animated')

var {
  AppRegistry,
  View,
  Image,
  Platform,
  findNodeHandle,
  StyleSheet
} = ReactNative;

var Animated = require('./Animated');

var BlurViewWrapper = createReactClass(
{
  getDefaultProps : function()
  {
    return {
      blurType : "light",
      initialOpacity : 1,
      imageName : "",
      viewToBlur : 0,
      innerView : <View />,
      children : null
    }
  },

  getInitialState : function()
  {
    return {
      opacity: new Animated.Value(this.props.initialOpacity),
    }
  },

  componentDidMount : function()
  {
  },

  fadeOut : function(completion)
  {
    Animated.timing(
      this.state.opacity,
      {toValue: 0, duration:200},
    ).start(function()
    {
      completion();
    });
  },

  setOpacity: function(opacity)
  {
    if( opacity >= 1 && this.state.opacity >= 1 ) return; // no change
    if( opacity <= 0 && this.state.opacity <= 0 ) return; // no change

    opacity = Math.min(Math.max(0,opacity),1);

    this.setState({opacity:new Animated.Value(opacity)});
  },

  imageLoaded: function() {
    this.setState({viewRef: findNodeHandle(this.refs.backgroundImage)})
  },

  render: function()
  {
    var {style, children, ...other} = this.props;
    var addedStyle = {flex:1};//{opacity : this.state.opacity};
    var outerStyle = {};
    if( typeof style === 'undefined' )
    {
      outerStyle = [addedStyle];
      style = [addedStyle, {opacity:this.state.opacity}];
    }
    else
    {
      outerStyle = [style, addedStyle];
      style = [style, addedStyle, {opacity:this.state.opacity}];
    }

    if( this.props.imageName != "" )
    {
      var innerStyle = {position:'absolute', top:0, left:0, bottom:0, right:0, opacity:this.state.opacity};
      return (
        <View style={StyleSheet.flatten(outerStyle)}>
          <Image
            style={{position:'absolute', top:0, left:0, right:0, bottom:0}}
            source={{uri: this.props.imageName}}>
          </Image>
          <Animated.View style={innerStyle}>
            <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(0,0,0,.2)'}} />
              {children}
          </Animated.View>
        </View>
      )
    }

    return (<Animated.View style={[style, {backgroundColor:'rgba(0,0,0,.4)'}]}>
        <View style={{position:'absolute', top:0, left:0, right:0, bottom:0, backgroundColor:'rgba(0,0,0,.2)'}} />
          {children}
      </Animated.View>);
  }
});

module.exports = {BlurView : BlurViewWrapper, VibrancyView : BlurViewWrapper};



// WEBPACK FOOTER //
// ./src/wrappers/react-native-blur-wrapper.js